import Vue from 'vue'
import App from './App.vue'
import router from './router'

import store from './store'
import './assets/css/main.less'
import components from './components/components'

import './filters.js'
//引入的第三方插件

import {vTosUsingGET, servedataUsingGET,servedetailUsingGET,servedetail2UsingPOST} from './api/dataapi'

function Fn(res) {
  let clientWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  if (!clientWidth) return
  let fontSize = clientWidth / 1920
  return res * fontSize
}
const colorsArr = [
  {
    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
    stops: [
      [0, '#FAD233'],
      [1, '#FFCC00'],
    ],
  },
  {
    linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
    stops: [
      [0, '#01D9FE'],
      [1, '#0477D5'],
    ],
  },
  '#F9E2C0',
  '#F67D3E',
  '#00B053',
]

Vue.config.productionTip = false
Vue.use(components)

// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import {
    BarChart,
    LineChart,
    PieChart,
    FunnelChart,
    MapChart,
    ScatterChart,
    LinesChart,
    EffectScatterChart
} from 'echarts/charts';
// 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
    DatasetComponent,
    DataZoomComponent,
    ToolboxComponent,
    VisualMapComponent
} from 'echarts/components';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import {
  SVGRenderer
} from 'echarts/renderers';

// 注册必须的组件
echarts.use(
    [EffectScatterChart, LinesChart, ScatterChart, VisualMapComponent, MapChart, FunnelChart, PieChart, LineChart, DataZoomComponent, DatasetComponent, TitleComponent, TooltipComponent, GridComponent, BarChart, SVGRenderer, LegendComponent, ToolboxComponent]
);
Vue.prototype.getImg = function(src){
  return require(`./assets/${src}.svg`);
}
Vue.prototype.$echarts = echarts
Vue.prototype.fontSizeFn = Fn
Vue.prototype.toNumber = function(...arg){
  return arg?.[0]?.map(item => item !== null ? Number(!isNaN(arg[1]) ? (Number(item) * (arg[2] || 1) ).toFixed(arg[1]) : item ) : null)
}
Vue.prototype.toStockData = function(arr1,arr2){
  if(!arr2){
    return false
  }
  let arr = []
  arr1.forEach((item,index) => {
    arr.push([Date.UTC(new Date(item).getFullYear(), new Date(item).getMonth(), new Date(item).getDate()), arr2[index] !== null ? Number(arr2[index]) : null])
  })
  return arr;
}
Vue.prototype.pieData = function(arr1,arr2, fn = (val) => {return val}){
  let arr = []
  arr1.forEach((item, index) => {
    arr.push([item && fn(item), arr2[index] !== null ? Number(arr2[index]) : null])
  })
  return arr
}
Vue.prototype.$Bus = new Vue()

Vue.prototype.getMoreData = function(index, res){
  let arr = []
  res.x.forEach((item, i) => {
    arr.push({
      name: res['s1'][i],
      value: Number(res[`s${index + 1 + 1}`][i])
    })
  })
  return arr
}
//-------------------------------------------------------------------------
Vue.prototype.getClickSecond = function(id, name, chart, args){
  servedataUsingGET({ chartid: id }).then(res => {
    let data = [];
    let secondData = [];
    res.x.forEach((item, index) => {
      secondData.push({
        value: Number(res.s2[index]),
        name: res.s1[index],
        id: item
      })
      const obj = data.find(val => val.name === item);
      if(obj){
        obj.value += Number(res.s2[index]);
      }else{
        data.push({
          value: Number(res.s2[index]),
          name: item
        })
      }
    })
    this[name] = {
      first: data,
      second: secondData
    }
    const dataObj = {
      xAxis: {
        show: false
      },
      toolbox: {
        show: true,
        feature: {
          myTool1: {
            iconStyle: {
              borderColor: '#fff'
            },
            show: true,
            title: 'back',
            icon: 'path://M700.371228 394.525472 174.028569 394.525472l255.952416-227.506551c12.389168-11.011798 13.505595-29.980825 2.492774-42.369993-11.011798-12.386098-29.977755-13.506619-42.367947-2.492774L76.425623 400.975371c-6.960529 5.496178-11.434423 14.003945-11.434423 23.561625 0 0.013303 0.001023 0.026606 0.001023 0.039909 0 0.01228-0.001023 0.025583-0.001023 0.037862 0 0.473791 0.01535 0.946558 0.037862 1.418302 0.001023 0.016373 0.001023 0.032746 0.001023 0.049119 0.39295 8.030907 3.992941 15.595186 10.034541 20.962427l315.040163 280.028764c5.717212 5.083785 12.83533 7.580652 19.925818 7.580652 8.274454 0 16.514115-3.403516 22.442128-10.07445 11.011798-12.387122 9.896394-31.357172-2.492774-42.367947l-256.128425-227.665163 526.518668 0c109.219517 0 198.075241 88.855724 198.075241 198.075241s-88.855724 198.075241-198.075241 198.075241L354.324888 850.696955c-16.57449 0-30.011524 13.437034-30.011524 30.011524s13.437034 30.011524 30.011524 30.011524l346.046341 0c142.31631 0 258.098289-115.783003 258.098289-258.098289S842.686515 394.525472 700.371228 394.525472z',
            onclick: () => {
              //返回
              const dataObj = {
                xAxis: {
                  show: false
                },
                legend: {
                  show: false
                },
                tooltip: {
                  trigger: 'item',
                  confine: true,
                  axisPointer: {
                    type: 'shadow',
                    crossStyle: {
                      color: '#999',
                    },
                  },
                  textStyle: {
                    color: '#ffffff'
                  },
                  extraCssText: 'border-color: rgba(0, 0, 0, 0.5);background-color: rgba(0, 0, 0, 0.5);',
                },
                series: [
                  {
                    name: name,
                    type: 'pie',
                    radius: '65%',
                    selectedMode: 'single',
                    selectedOffset: this.fontSizeFn(10),
                    clockwise: true,
                    data: this[name].first,
                    label:{
                      color: '#fff',
                      formatter: '{b} ({c})'
                    },
                    emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                  }
                ]
              }
              Object.assign(this[args.name], dataObj)
              chart.setOption(dataObj, { replaceMerge: ['tooltip', 'series'] })
            }
          },
        }
      },
      legend: {
        show: false
      },
      tooltip: {
        trigger: 'item',
        confine: true,
        axisPointer: {
          type: 'shadow',
          crossStyle: {
            color: '#999',
          },
        },
        textStyle: {
          color: '#ffffff',
          fontSize: Fn(18)
        },
        extraCssText: 'border-color: rgba(0, 0, 0, 0.5);background-color: rgba(0, 0, 0, 0.5);',
      },
      series: [
        {
          name: name,
          type: 'pie',
          radius: '65%',
          selectedMode: 'single',
          selectedOffset: this.fontSizeFn(10),
          clockwise: true,
          data,
          label:{
            color: '#fff',
            formatter: '{b} ({c})',
          },
          emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
          }
        }
      ]
    }
    Object.assign(this[args.name], dataObj);
    chart.setOption(dataObj, { replaceMerge: ['tooltip', 'series', 'yAxis'] })
  })
}
Vue.prototype.getTrueData = function(res, nameArr, chart, args, fn){
  let ySortArr = [];
  new Promise(resolve => {
    let arr = [];
    nameArr[0].forEach((item,index) => {
      const dataNumbers = args?.isStock ? this.toStockData(res.x, res[`s${index + (args?.startIndex ? args.startIndex : 0) + 1 + (args.fromIndex || 0)}`]) : ( args?.isMore ? this.getMoreData(index, res) : this.toNumber(res[`s${index + (args?.startIndex ? args.startIndex : 0) + 1 + (args.fromIndex || 0)}`], args?.fixed, args?.percentage));
      nameArr[2] && (() => {
        const obj = ySortArr.find(item => item.type == nameArr[2][index])
        const max = Math.ceil(Math.max(...dataNumbers)) + ((args.yAxisLines || 5 ) - Math.ceil(Math.max(...dataNumbers)) % (args.yAxisLines || 5 ));
        if(obj){
          if(max > obj.maxNum){
            obj.maxNum = max;
          }
        }else{
          ySortArr.push({
            type: nameArr[2][index],
            maxNum: max
          })
        }
      })();
      arr.push({
        ...{
          name: item,
          type: nameArr[1][index],
          data: dataNumbers
        },
        ...(args?.stack ? {
            stack: 'xx'
          }
        : {}),
        ...(args?.label ? {
          label: {
            show: true,
            color: '#fff',
            fontWeight: 'bold',
            ...(args?.rotateLabel ?
            {
              rotate: 90,
              align: 'left',
              verticalAlign: 'middle',
              position: 'insideBottom',
              distance: 0,
              formatter: function(params){
                return `${params.name.length > args.subStrIndex ? params.name.substr(0, args.subStrIndex) + '...' : params.name} (${params.value})`
              }
            } : {})
          }
        } : {}),
        ...(nameArr[2] ?  {
          yAxisIndex: nameArr[2][index]
        } : {})
      })
    });
    //-------------------------------------
    const dataObj = {
      toolbox: {
        show: false
      },
      xAxis: {
        show: true,
        type: 'category',
        axisLabel: {
          show: args?.rotateLabel ? false : true,
          fontSize: Fn(16)
        },
        data: res.x
      },
      ...(nameArr[2] ? (() => {
        const newArr = [];
        const arr = ['left', 'right'];
        const setArr = Array.from(new Set(nameArr[2]));
        setArr.forEach((item, index) => {
          newArr.push({
            type: 'value',
            min: 0,
            position: arr[index],
            max: args.isRounding ? Math.ceil(ySortArr.find(item => item.type == index).maxNum / 1000) * 1000 : ySortArr.find(item => item.type == index).maxNum,
            interval: args.isRounding ? Math.ceil(ySortArr.find(item => item.type == index).maxNum / 1000) * 1000 / (args.yAxisLines || 5 ) : ySortArr.find(item => item.type == index).maxNum / (args.yAxisLines || 5 )
          })
        })
        return {
          yAxis: newArr
        };
      })() : {}),
      legend: {
        ...this[args.name].legend,
        show: args?.notShowlegend ? false : true
      },
      series: args?.isReverse ? arr.reverse() : arr,
      ...(args?.isAxis ? (() => {
        let sortArr = [...arr[0].data];
        sortArr.sort((a,b) => {
          return Math.abs(a) - Math.abs(b)
        })
        const absNum = Math.ceil(Math.abs(sortArr[sortArr.length - 1]))
        return {
          yAxis: {
            minInterval: absNum
          }
        }
      })() : {} )
    }
    args.clickFn && (dataObj.clickFn = args.clickFn) && chart.off('click') && chart.on('click', args.clickFn);
    args.getZrFn && (dataObj.getZrFn = args.getZrFn) && chart.getZr().on('click', args.getZrFn);
    Object.assign(this[args.name], dataObj)
    chart.setOption(dataObj, { replaceMerge: ['series'] })
    resolve(res);
  }).then(res => {
    if(fn) fn(res);
  })
}
/*
@params hasMoreData----更多的数据
*/
function hasMoreFn(index, res, args){
  const arr = []
  res.x.forEach((item, i) => {
    const obj = {
      name: item,
      value: res[`s${index}`][i].replaceAll(/\s/g, '') && (args.fixed ? Number(res[`s${index}`][i]).toFixed(args.fixed) : Number(res[`s${index}`][i]))
    }
    args.hasMoreData.forEach(val => {
      obj[val] = res[val]?.[i]
    })
    arr.push(obj);
  })
  return arr;
}
//新接口
Vue.prototype.getNewVTos = function(params, nameArr, chart, args, fn){
  vTosUsingGET({
    chartid: params.id,
    stype: params.stype
  }).then(resData => {
    return this.getChartsDatas(resData, nameArr, chart, args);
  }).then(res => {
    if(fn) fn(res)
  })
}
Vue.prototype.getFunnel = function(params, args){
  vTosUsingGET({
    chartid: params.id,
    stype: params.stype
  }).then(res => {
    const arr = [];
    res.x.forEach((item, index) => {
        const obj = { name: item };
        obj.value = res[args.valueKey][index];
        args.hasMoreData && args.hasMoreData.forEach(val => {
          obj[val] = res[val][index]
        })
        arr.push(obj);
    })
    const series = [
      {
        name: args.seriesName,
        type: 'funnel',
        sort: 'ascending',
        left: '0%',
        top: '0',
        bottom: '5%',
        width: '100%',
        label: {
          show: true,
          position: 'inside',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: Fn(14),
          textBorderColor: '#000',
          textBorderWidth: 2,
          ...args.labelStyle
        },
        ...args.otherStyle,
        data: arr
      }
    ]
    Object.assign(this[args.name], { series });
    args.chart.setOption({ series }, { replaceMerge: ['series'] })
  })
}
//获取数据
Vue.prototype.getChartsDatas = function(res,nameArr,chart, args){
  let arr = [];
  let ySortArr = [];
  nameArr[0].forEach((item,index) => {
    const dataNumbers = args?.hasMoreData
      ?
      hasMoreFn((args?.startIndex || 1) + index, res, args)
      :  
    (args?.isStock ? this.toStockData(res.x, res[`s${index + (args?.startIndex ? args.startIndex : 0) + 1}`]) : ( args?.isMore ? this.getMoreData(index, res) : this.toNumber(res[`s${index + (args?.startIndex ? args.startIndex : 0) + 1}`], args?.fixed)));
    nameArr[2] && (() => {
      const obj = ySortArr.find(item => item.type == nameArr[2][index])
      let maxNumbers = Math.ceil(Math.max(...dataNumbers));
      if(args.hasMoreData){
        //数据结构 [ { name: String; value: Number } ]
        maxNumbers = Math.ceil(Math.max(...dataNumbers.map(item => item.value)))
      }
      let max = maxNumbers + ((args.yAxisLines || 5 ) - maxNumbers % (args.yAxisLines || 5 ));
      if(args.yMaxArr?.[nameArr[2][index]]){
        max = args.yMaxArr?.[nameArr[2][index]]
      }
      if(obj){
        if(max > obj.maxNum){
          obj.maxNum = max;
        }
      }else{
        ySortArr.push({
          type: nameArr[2][index],
          maxNum: max
        })
      }
    })();
    arr.push({
      ...{
        name: item,
        type: nameArr[1][index],
        data: dataNumbers
      },
      ...(args?.lineArea?.[index] ? {
        areaStyle: {},
        smooth: true
      } : {}),
      ...(args?.stack ? {
          stack: 'xx'
        }
      : {}),
      ...(args?.stackArr?.[index] ? {
        stack: args?.stackArr?.[index]
      } : {}),
      ...(args?.zArr ? {
        z: args.zArr[index]
      }: {}),
      ...(args?.label || args?.labelArr?.[index] ? {
        label: {
          show: true,
          color: '#fff',
          fontWeight: 'bold',
          ...(args?.rotateLabel ?
          {
            rotate: 90,
            align: 'left',
            verticalAlign: 'middle',
            position: 'insideBottom',
            distance: 0,
            formatter: function(params){
              return `${params.name.length > args.subStrIndex ? params.name.substr(0, args.subStrIndex) + '...' : params.name} (${params.value})`
            }
          } : {})
        }
      } : {}),
      ...(nameArr[2] ?  {
        yAxisIndex: nameArr[2][index]
      } : {}),
      ...(args?.moreSetting?.[index])
    })
  });
  //-------------------------------------
  const dataObj = {
    ...args.otherSettings,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      ...this[args.name].tooltip
    },
    xAxis: {
      show: true,
      type: 'category',
      axisLabel: {
        show: args?.rotateLabel ? false : true,
        textStyle: {
          fontSize: Fn(16)
        }
      },
      data: res.x
    },
    ...(nameArr[2] ? (() => {
      const newArr = [];
      const arr = ['left', 'right'];
      const setArr = Array.from(new Set(nameArr[2]));
      setArr.forEach((item, index) => {
        newArr.push({
          axisLabel: {
            fontSize: Fn(16)
          },
          type: 'value',
          min: 0,
          position: arr[index],
          max: args.isRounding ? Math.ceil(ySortArr.find(item => item.type == index).maxNum / 1000) * 1000 : ySortArr.find(item => item.type == index).maxNum,
          interval: args.isRounding ? Math.ceil(ySortArr.find(item => item.type == index).maxNum / 1000) * 1000 / (args.yAxisLines || 5 ) : ySortArr.find(item => item.type == index).maxNum / (args.yAxisLines || 5 )
        })
      })
      return {
        yAxis: newArr
      };
    })() : {}),
    legend: {
      ...this[args.name].legend,
      show: args?.notShowlegend ? false : true
    },
    series: args?.isReverse ? arr.reverse() : arr,
    ...(args?.isAxis ? (() => {
      let sortArr = [...arr[0].data];
      sortArr.sort((a,b) => {
        return Math.abs(a) - Math.abs(b)
      })
      const absNum = Math.ceil(Math.abs(sortArr[sortArr.length - 1]))
      return {
        yAxis: {
          minInterval: absNum
        }
      }
    })() : {} )
  }
  args.clickFn && (dataObj.clickFn = args.clickFn) && chart.off('click') && chart.on('click', args.clickFn);
  args.getZrFn && (dataObj.getZrFn = args.getZrFn) && chart.getZr().on('click', args.getZrFn);
  Object.assign(this[args.name], dataObj)
  chart.setOption(dataObj, { replaceMerge: ['series'] })
  return Promise.resolve(res);
}
Vue.prototype.getEchartsData = function(id, nameArr,chart, args, fn){
  return servedataUsingGET({chartid: id, local: window.navigator.language.includes('zh') ? 'zh_CN' : 'us_EN' }).then(res => {
    this.getChartsDatas(res);
  }).then(res => {
    if(fn) fn(res);
  })
}
Vue.prototype.getVTosData = function(params, ...args){
  vTosUsingGET({
    chartid: params.id,
    stype: params.stype
  }).then(resData => {
    this.getTrueData(resData, ...args);
  })
}
Vue.prototype.changeToPie = function(res, name, chart, args, fn){
  let data = []
  res.x.forEach((item, index) => {
    const obj = {
      value: Number(res[`s${args.fromIndex || 1}`][index]),
      name: item,
    }
    args?.otherKeys?.forEach(val => {
      obj[val] = res[val][index]
    })
    data.push(obj)
  })
  const dataObj = {
    series: [
      {
        name: name,
        type: 'pie',
        radius: '75%',
        avoidLabelOverlap: true,
        selectedOffset: this.fontSizeFn(10),
        clockwise: true,
        data,
        label:{
          color: '#fff',
          overflow: 'break',
          formatter: args.LableFormatter || '{b} ({c})'
        },
        emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
        }
      }
    ]
  }
  args.clickFn && (dataObj.clickFn = args.clickFn) && chart.off('click') && chart.on('click', args.clickFn);
  Object.assign(this[args.name], dataObj)
  chart.setOption(dataObj, { replaceMerge: ['series'] });
  fn && fn(res);
}

Vue.prototype.getPieVosData = function(params, ...args){
  vTosUsingGET({
    chartid: params.id,
    stype: params.stype
  }).then(resData => {
    this.changeToPie(resData, ...args);
  })
}
Vue.prototype.getEchartsPie = function(id, name, chart, args){
  servedataUsingGET({chartid: id}).then(res => {
    let data = [];
    res.x.forEach((item, index) => {
      data.push({
        value: Number(res.s1[index]),
        name: item
      })
    })
    const dataObj = {
      toolbox: {
        show: false
      },
      xAxis: {
        show: false
      },
      legend: {
        show: false
      },
      tooltip: {
        trigger: 'item',
        confine: true,
        axisPointer: {
          type: 'shadow',
          crossStyle: {
            color: '#999',
          },
        },
        textStyle: {
          color: '#ffffff',
          fontSize: Fn(18)
        },
        extraCssText: 'border-color: rgba(0, 0, 0, 0.5);background-color: rgba(0, 0, 0, 0.5);',
      },
      series: [
        {
          name: name,
          type: 'pie',
          radius: '65%',
          selectedMode: 'single',
          avoidLabelOverlap: true,
          selectedOffset: this.fontSizeFn(10),
          clockwise: true,
          data,
          label:{
            color: '#fff',
            overflow: 'break',
            formatter: '{b} ({c})'
          },
          emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
          }
        }
      ]
    }
    args.clickFn && (dataObj.clickFn = args.clickFn) && chart.off('click') && chart.on('click', args.clickFn);
    Object.assign(this[args.name], dataObj)
    chart.setOption(dataObj, { replaceMerge: ['tooltip', 'series', 'yAxis'] })
  })
}
//横向百分比
Vue.prototype.TransverseColumns = function(params, args){
  vTosUsingGET({
    chartid: params.id,
    stype: params.stype
  }).then(resData => {
    const obj = {
      xAxis: {
        type: 'value',
        max: 100,
        splitLine: {
          show: false
        },
        axisLabel:{
          show: false
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        ...this[args.name].tooltip
      },
      legend: {
        show: args.notShowLegend ? false : true
      },
      yAxis: {
        type: 'category',
        data: resData.x,
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          fontSize: this.fontSizeFn(16)
        }
      },
    };
    let arr = [];
    args.nameArr[0].forEach((item, index) => {
      const dataNumbers = args?.hasMoreData
        ?
        hasMoreFn((args?.startIndex || 1) + index, resData, args)
        :  
      (this.toNumber(resData[`s${index + (args?.startIndex ? args.startIndex : 0) + 1}`], args?.fixed));
      arr.push({
        name: item,
        type: args.nameArr[1][index],
        data: dataNumbers,
        showBackground: true,
        ...args?.dataSettings
      })
    })
    obj.series = arr;
    args.clickFn && (obj.clickFn = args.clickFn) && args.chart.off('click') && args.chart.on('click', args.clickFn);
    args.getZrFn && (obj.getZrFn = args.getZrFn) && args.chart.getZr().on('click', args.getZrFn);
    Object.assign(this[args.name], obj)
    args.chart.setOption(obj, { replaceMerge: ['series', 'legend'] })
  })
}
Vue.prototype.resDataToBar = function(resData, objData){
  const series = [];
  let max = 0;
  function getMaxArr(arr){
    const obj = [];
    arr.forEach((item) => {
      item.forEach((val, i) => {
        obj[i] || (obj[i] = 0);
        obj[i] += Number(val);
      })
    })
    return Math.ceil(Math.max(...obj));
  }
  const Allarr = [];
  objData.nameArr.forEach((item, index) => {
    const dataNumbers = this.toNumber(resData[`s${index + (objData?.startIndex ? objData.startIndex : 0) + (objData.fromIndex || 0)}`]);
    if(objData.sameAxis){
      Allarr.push(dataNumbers);
    }else{
      let maxNumbers = Math.ceil(Math.max(...dataNumbers));
      const nowMax = maxNumbers + ((objData.yAxisLines || 5 ) - maxNumbers % (objData.yAxisLines || 5 ));
      if(nowMax > max){
        max = nowMax;
      }
    }
    const data = [];
    resData.x.forEach((val, i) => {
      const obj = {
        value: resData[`s${objData.fromIndex + index}`][i],
        label: {
          show: objData.showLabel ? true : false,
          color: '#ffffff',
          ...(objData.labelFn?.(resData, index, i))
        }
      }
      objData.hasMoreData?.forEach(item => {
        obj[item] = resData[item]?.[i];
      })
      data.push(obj);
    })
    series.push({
      name: item,
      type: objData.typeArr[index],
      stack: objData.stackArr?.[index],
      data,
      ...(objData.yAxisArrData ?  {
        yAxisIndex: objData.yAxisArrData[index]
      } : {}),
    })
  })
  if(objData.sameAxis){
    const maxVal = getMaxArr(Allarr);
    max = maxVal + ((objData.yAxisLines || 5 ) - maxVal % (objData.yAxisLines || 5 ))
  }
  const obj = {
    [objData.moduleType]: {
      type: 'category',
      data: resData[objData.xName || 'x'],
      axisLabel: {
        fontSize: Fn(16),
        interval: 0,
      },
    },
    series,
    xAxis: {
      type: 'value',
      min: 0,
      max: max,
      interval: Math.ceil(max / (objData.yAxisLines || 5 ))
    }
  }
  Object.assign(this[objData.name], obj);
  this.$refs[objData.name].myChart.setOption(obj, { replaceMerge: ['series'] })
}
Vue.prototype.dataBar = function(params, objData){
  vTosUsingGET({
    chartid: params.id,
    stype: params.stype
  }).then(resData => {
    this.resDataToBar(resData, objData);
  })
}
Vue.prototype.getPieChart = function(params , objData){
  vTosUsingGET({
    chartid: params.id,
    stype: params.stype
  }).then(resData => {
    resData.x.forEach((item, index) => {
      const data = [];
      objData.Percentage
      &&
      this.$set(this[objData.names[index]], 'Percentage', resData[objData.Percentage][index] * 1000 / 10 + '%')
      for(let i = 0; i < objData.nameArr.length; i++){
          data.push({
              value: resData[`s${objData.fromIndex + i}`][index],
              name: objData.nameArr[i],
              total: resData[`s${objData.totalIndex}`]?.[index]
          })
      }
      const obj = {
          title: objData.titleNotShow ? {
            show: false
          } : {
              text: `${item} (${resData[objData.Percentage]?.[index] * 1000 / 10 + '%'})`,
              left: 'center',
              textStyle: {
                  color: '#fff'
              }
          },
          series: [
              {
                  name: '',
                  type: 'pie',
                  radius: '65%',
                  selectedMode: 'single',
                  ...(objData.selectedOffset && {
                    selectedOffset: objData.selectedOffset
                  }),
                  clockwise: true,
                  data,
                  label: objData.label || {
                    overflow: 'break',
                    color: '#fff',
                    formatter: '{b} ({c})',
                    ...(objData.labelFontSize && {
                      fontSize: objData.labelFontSize
                    })
                  },
                  emphasis: {
                      itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                  }
              }
          ]
      }
      Object.assign(this[objData.names[index]], obj);
      objData.chartArr[index].setOption(obj, { replaceMerge: ['series', 'title'] })
    })
  })
}
Vue.prototype.getMultipleBar = function(params, objData){
  vTosUsingGET({
    chartid: params.id,
    stype: params.stype
  }).then(resData => {
    objData.moduleTitle.forEach((val, i) => {
      const series = []
      objData.nameArr.forEach((item, index) => {
        series.push({
            name: item,
            type: objData.typeArr[index],
            stack: objData.stackArr?.[index],
            label: {
                show: false
            },
            data: resData[`s${objData.fromIndex + index}`].filter((dataItem, dataIndex) => resData[objData.typeIndex][dataIndex] == val)
        })
      })
      const obj = {
        [objData.moduleTypeArr[i]]: {
            type: 'category',
            data: resData.x.filter((dataItem, index) => resData[objData.typeIndex][index] == val),
            axisLabel: {
              fontSize: Fn(16)
            }
        },
        series
      }
      Object.assign(this[objData.datanameArr[i]], obj);
      this.$refs[objData.datanameArr[i]].myChart.setOption(obj, { replaceMerge: ['series'] })
    })
  })
}
//-------------------------------------------------------------------------
Vue.prototype.basicsFn = function(id, name, nameArr, isReverse = false, isAxis = false, other = []){
  servedataUsingGET({chartid: id}).then(res => {
      let arr = [];
      nameArr.forEach((item,index) => {
          arr.push({
              name: item,
              data: this.toNumber(res[`s${index + 1}`]),
              ...(other[index] ? other[index] : {}),
              color: isReverse && colorsArr[index]
          })
      });
      if(isAxis){
        let sortArr = [...arr[0].data];
        sortArr.sort((a,b) => {
          return Math.abs(a) - Math.abs(b);
        })
        const absNum = Math.ceil(Math.abs(sortArr[sortArr.length - 1]))
        this[name].yAxis.tickPositions = [-absNum, 0, absNum]
      }
      this[name].xAxis.categories = res.x;
      this[name].series = isReverse ? arr.reverse() : arr;
  })
}
Vue.prototype.getTableData = async function(id, stype){
  let thDatas = {}, tdDatas = [], widthObj = {};
  const res = await servedetail2UsingPOST({dataDetails: [{ chartid: id, dataindex: 0, stype: 'Title' }, { chartid: id, dataindex: 0, stype: 'Width' }, { chartid: id, dataindex: 0, stype: stype }], modulename: 'uganda'})
  widthObj = res[1]
  for(let key in res[0]){
    if(key.includes('v') && !Number.isNaN(Number(key.split('v')[1])) && res[0][key] != null ){
      thDatas[key] = res[0][key]
    }
  }
  tdDatas = res.slice(2)
  return {
    thDatas,
    tdDatas,
    widthObj
  }
}
Vue.prototype.tableFn = async function(id, num, isFixed=false, stype = 0){
  let arr = [];
  const res = await servedetailUsingGET({ chartid: id, dataindex: 0, stype: stype })
  res.forEach(item => {
    for(let i = 0;i<num;i++){
      if(isFixed){
        if(i <= isFixed.numIndex){
          arr.push(item[`v${i + 1}`])
        }else{
          if(Number(item[`v${i + 1}`]) >= 0 || !item[`v${i + 1}`].includes('.')){
            //大于等于0 或者 不是小数
            arr.push(Number(item[`v${i + 1}`]).toFixed(isFixed.fixedNum))
          }else{
            //小于0 并且 为 小数 截取
            arr.push(Number(item[`v${i + 1}`].substr(0, item[`v${i + 1}`].length - item[`v${i + 1}`].split('.')[1].length + isFixed.fixedNum)))
          }
        }
      }else{
        arr.push(item[`v${i + 1}`])
      }
    }
  })
  return arr;
}
//阶段性请求
Vue.prototype.getAllPromise = function(arrPromise, startNum = 0){
  if(arrPromise.length > startNum){
    return Promise.all(arrPromise.slice(startNum, startNum + 2).map(item => item())).then(() => {
      return true;
    }).catch(err => {
      throw err;
    }).finally(() => {
      this.getAllPromise(arrPromise, startNum + 2);
    })
  }
}
export default new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')